import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { loadSWNoticeSummary } from "../../../../store/manageSW/manageSWActions";
import useSelector from "../../../../store/useSelector";
import SWStepNotices from "./SWStepNotices";

interface IManageSWNoticeSummaryProps {
    swGuid: string,
    swVersion: number
}

const ManageSWNoticeSummary: React.FC<IManageSWNoticeSummaryProps> = ({ swGuid, swVersion }) => {
    const {
        swNoticeData,
        swStepNoticeData,
        SW: {
            steps
        },
    } = useSelector(store => store.manageSW);
    const dispatch = useDispatch();
    const isPresentSWNotices = swNoticeData.swNotices === undefined ? false : swNoticeData.swNotices?.length > 0 ? true : false;
    const isPresentStepNotices = swStepNoticeData.swStepNotices === undefined ? false : swStepNoticeData.swStepNotices?.length > 0 ? true : false;

    useEffect(() => {
        dispatch(loadSWNoticeSummary({ swGuid, swVersion }));
    }, [dispatch, swGuid, swVersion]);

    const parseHTML = (htmlString: string): React.ReactNode[] => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(htmlString, "text/html");
        const container = doc.body || doc;
        const elements: React.ReactNode[] = [];

        if (!container.childNodes.length) {
            return [htmlString];
        }

        container.childNodes.forEach((node, index) => {
            if (node.nodeType === Node.TEXT_NODE) {
                elements.push(node.textContent);
            } else if (node.nodeType === Node.ELEMENT_NODE) {
                const element = node as Element;
                if (element.tagName === "A") {
                    elements.push(
                        <a key={index} href={element.getAttribute("href") || "#"} target="_blank" rel="noopener noreferrer">
                            {element.textContent}
                        </a>
                    );
                }
            }
        });

        return elements;
    };

    return (
        <div className="notice-container">
            <div className="sw-notices">
                <div>
                    {(isPresentSWNotices || isPresentStepNotices) &&
                        <label className="title">StandardWork Notices</label>}
                </div>
                <div>
                    <ul>
                        {swNoticeData?.swNotices?.map((x, index) => (
                            <li key={index}>
                                {parseHTML(x.text.replace(/<\/?p>/g, ''))}
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
            {steps
                .map((step, index) => (
                    <SWStepNotices key={index} {...step} />
                ))}
        </div>)
}

export default ManageSWNoticeSummary;